import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/ProfileImage.png";
import { Button } from "@mui/material";
import { Player } from "video-react";
import Stack from "@mui/material/Stack";
import { AiOutlineClockCircle } from "react-icons/ai";
import Rating from "@mui/material/Rating";
import { useNavigate } from "react-router-dom";
const NotificationView = () => {
  const navigate = useNavigate();
  const TotalStudentList = [
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
  ];
  return (
    <SideMenu>
      <div className="page-data-view-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
              <div className="video-section-main">
                <BackHeader backHanler={() => navigate(-1)} />
                <Player
                  className="play"
                  playsInline
                  poster={ProfileImg}
                  src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                />
                <div className="video-section-header-main">
                  <p className="video-section-header-heading">
                    Integer facilisis pulvinar molestie. Duis justo lectus
                  </p>
                  <div className="video-section-header-date-main">
                    <AiOutlineClockCircle color="#303030" />
                    <p className="video-section-header-date">
                      JAN 31, 2022, 10:30 AM
                    </p>
                  </div>
                </div>
                <p className="video-description">
                  Quisque a fringilla nisi, nec suscipit justo. Pellentesque
                  habitant morbi tristique senectus et netus et malesuada fames
                  ac turpis egestas. Fusce nulla odio, mattis vel nibh eget,
                  suscipit laoreet libero.
                </p>
                <p className="video-section-user-heading">Tutor Name</p>
                <div className="video-section-user-profile-main">
                  <div className="video-section-user-data-container">
                    <img
                      src={ProfileImg}
                      className="video-section-user-profile-image"
                    />
                    <div>
                      <p className="video-section-user-name">David anderson</p>
                      <p className="video-section-user-location">burnside</p>
                    </div>
                  </div>
                </div>
                <p className="video-section-review-heading">
                  Ratings & Reviews
                </p>
                <div className="box-rating-main">
                  <div className="box-rating-header">
                    <img src={ProfileImg} className="box-list-image" />

                    <div className="box-rating-second-section">
                      <div>
                        <p className="box-rating-username">Johan smith</p>
                        <p className="box-rating-time">5 Lectures, 45 min</p>
                      </div>
                      <div className="box-rating-show">
                        <Stack spacing={1}>
                          <Rating
                            name="half-rating-read"
                            defaultValue={5}
                            precision={1}
                            readOnly
                          />
                        </Stack>
                        <p className="box-rating-day">Yesterday</p>
                      </div>
                    </div>
                  </div>
                  <p className="box-rating-message">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                    in lorem congue, euismod urna vitae, porttitor mi. Aliquam
                    consectetur eu turpis ac congue.
                  </p>
                </div>
                <div className="box-rating-main">
                  <div className="box-rating-header">
                    <img src={ProfileImg} className="box-list-image" />

                    <div className="box-rating-second-section">
                      <div>
                        <p className="box-rating-username">Johan smith</p>
                        <p className="box-rating-time">5 Lectures, 45 min</p>
                      </div>
                      <div className="box-rating-show">
                        <Stack spacing={1}>
                          <Rating
                            name="half-rating-read"
                            defaultValue={4}
                            precision={1}
                            readOnly
                          />
                        </Stack>
                        <p className="box-rating-day">Yesterday</p>
                      </div>
                    </div>
                  </div>
                  <p className="box-rating-message">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                    in lorem congue, euismod urna vitae, porttitor mi. Aliquam
                    consectetur eu turpis ac congue.
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="video-right-section-main">
                <Button
                  className="video-right-section-pdf-download-button"
                  variant="text"
                >
                  <p className="page-header-button-text">Download pDF</p>
                </Button>
                <p className="video-right-section-heading">
                  Total attend student - 10
                </p>
                {TotalStudentList.map((v, i) => {
                  return (
                    <div className="video-right-section-list-main">
                      <img
                        src={ProfileImg}
                        className="video-right-section-list-profile-image"
                      />
                      <p className="video-right-section-list-username">
                        {v.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default NotificationView;
